import { useCallback, useEffect, useRef } from 'react';
import { useAuth } from 'react-oidc-context';
import { useSettings } from './useSettings';
import { MULTI_BUTTON_PREFIX } from 'src/@vigo/vigo-multiButton';

export const useVigoLogout = () => {
  const { settings, saveSettings } = useSettings();

  const { signoutRedirect } = useAuth();

  // Refs ensure the stable handleLogout callback always reads the latest
  // settings and saveSettings without requiring them as deps (which would
  // defeat the memoisation and restart the idle-timer churn).
  const settingsRef = useRef(settings);
  const saveSettingsRef = useRef(saveSettings);
  useEffect(() => {
    settingsRef.current = settings;
    saveSettingsRef.current = saveSettings;
  });

  /**
   * Removes all customer configuration rules from the local storage.
   */
  const removeCustomerRulesConfig = useCallback((): void => {
    Object.keys(localStorage ?? {})
      .filter(key => key.startsWith('CustomerConfig-'))
      .forEach(key => localStorage.removeItem(key));
  }, []);

  const removeVigoMultiButtonState = useCallback((): void => {
    Object.keys(localStorage ?? {})
      .filter(key => key.startsWith(MULTI_BUTTON_PREFIX))
      .forEach(key => localStorage.removeItem(key));
  }, []);

  /**
   * Removes the 'account-configurations' item from session storage,
   * removes customer rules configuration, saves settings with an
   * updated current role, and calls the 'signoutRedirect' function.
   */
  const handleLogout = useCallback((): void => {
    sessionStorage.removeItem('account-configurations');
    removeCustomerRulesConfig();
    removeVigoMultiButtonState();
    saveSettingsRef.current({ ...settingsRef.current, currentRole: '' as string });

    // remove the session storage for the token
    // removeUser();
    signoutRedirect();
  }, [signoutRedirect]);

  return { handleLogout };
};
